import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl'

import MuiAppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';

import NavLogo from '../components/NavLogo';
import NavDrawer, { NavDrawerProvider, NavDrawerClasses } from '../components/NavDrawer';
import NavLinks from '../components/NavLinks';
import { usePreviewConfig, useFeatureEnables } from '../dataProviders';
import { ReactComponent as MenuSvg } from '../components/Menu.svg';

export { makeNavDrawerStyles } from '../components/NavDrawer';


export interface NavClasses {
  root?: string,
  toolbar?: string,
  paper?: string,
  menuLink?: string,
  link?: string,
  linkContainer?: string,
  socialMediaGrid?: string,
  socialMediaLink?: string,
  socialMediaLinkIcon?: string;
}

interface NavLogoClasses {
  textLogo?: string;
  root?: string;
  image?: string;
}

export default function NavBar({ navClasses={}, navDrawerClasses, logoClasses }:{
  navClasses: NavClasses,
  navDrawerClasses: NavDrawerClasses,
  logoClasses: NavLogoClasses
}) {
  const intl = useIntl();
  const { showMenuLinks, showSocialMedia } = useFeatureEnables();

  const { mobileNavOpen } = usePreviewConfig();
  const [drawerState, setDrawerState] = useState(false);
  const toggleDrawer = (isOpen: boolean) => (event: any) => { // TODO: Find the proper typing for this event
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerState(isOpen);
  };
  const openMobileNavAriaLabel = intl.formatMessage({ description: "openMobileNavAriaLabel", defaultMessage: "Open Navigation" });

  useEffect( () => {
    if( mobileNavOpen === true || mobileNavOpen === false ) {
      setDrawerState(mobileNavOpen);
    }
  }, [mobileNavOpen] );

  return (
    <NavDrawerProvider>
      <MuiAppBar position="static" classes={{ root: navClasses.root }}>
        <Toolbar classes={{ root: navClasses.toolbar }}>
          <Hidden smDown>
            <div>
              <NavLogo classes={logoClasses} />
              <div className={navClasses.linkContainer}>
                <span aria-label="Main Navigation">
                  <NavLinks linkClassName={navClasses.link} />
                </span>
              </div>
            </div>
          </Hidden>
          <Hidden mdUp>
            { (showMenuLinks || showSocialMedia) &&
              <Button onClick={toggleDrawer(true)} className={navClasses.menuLink} aria-label={openMobileNavAriaLabel}>
                <MenuSvg />
              </Button>
            }
            <NavLogo classes={logoClasses} />
            <NavDrawer toggleDrawer={toggleDrawer} open={drawerState} classes={navDrawerClasses} logoClasses={logoClasses} navClasses={navClasses} />
          </Hidden>
        </Toolbar>
      </MuiAppBar>
    </NavDrawerProvider>
  );
}
